@defer {
  <div class="w2c-panel w2c-panel--large" [class.w2c-panel--dark]="darkMode">
    <div class="w2c-panel-tab">
      @for (tab of tabs; track tab.key) {
        <a class="link" [class.active]="tab.isActive" (click)="selectTab(tab)"
          [ngClass]="{'locked': uiState && tab.feature && uiState[tab.feature].locked}">
          <i [ngClass]="tab.class"></i> {{ tab.key | translate }}
        </a>
      }
    </div>
  
    <asg-core-lookup #coreLkp (ContentChanged)="onContentChanged($event)" [darkMode]="darkMode"
      [documentId]="documentId" [lookupType]="activeTab && activeTab.lookupType" [uiState]="uiState">
    </asg-core-lookup>
  
    <footer class="w2c-panel-tab__footer">
      <div class="w2c-columns is-vcentered">
        @if (coreLkp.hmpButtonsList.length > 0) {
          <div class="w2c-column has-text-left">
            <i class="fas fa-headphones"></i>
            <p class="homophone-label">{{ 'LOOKUP.HOMOPHONES' | translate }}:</p>
            <div class="hmophones-h-list">
              @for (hmp of coreLkp.hmpButtonsList; track hmp) {
                <div class="hmophone-label-wrapper btn-circle">
                  <label (click)="coreLkp.doSearch(hmp.word)">{{hmp.word}}</label>
                </div>
              }
            </div>
            @if (coreLkp.hmpDropdownList.length > 0) {
              <div class="hmophones-dropdown-wrapper">
                <div class="btn-circle btn-circle__sound" (click)="onHmpListClick($event)">
                  <i class="fas fa-plus"></i>
                  <i class="fas fa-angle-up"></i>
                  @if (showHmpDropdown) {
                    <div class="homophones-dropdown-list">
                      @for (hmp of coreLkp.hmpDropdownList; track hmp) {
                        <label (click)="coreLkp.doSearch(hmp.word)">{{hmp.word}}</label>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
        <div class="w2c-column has-text-right">
          <div class="btn-circle btn-circle__play w2c2-tooltip" (click)="copyToClipboard(coreLkp.selection)">
            @if (!copied) {
              <i class="fal fa-copy"></i>
            }
            @if (copied) {
              <i class="far fa-check"></i>
            }
          </div>
          <div class="btn-circle btn-circle__play w2c2-tooltip" (click)="play()" [class.disabled]="!haveContentToRead || coreLkp.isPictureLookup">
            @if (!isPlaying) {
              <i class="fas fa-play"></i>
            }
            @if (isPlaying) {
              <i class="fas fa-pause"></i>
            }
          </div>
      </div>
      </div>
    </footer>
  </div>  
}
